'use client'

import { ApolloClient, InMemoryCache } from '@apollo/client'
import { getBearerToken } from '@sylveraio/auth-utils'
import { createDynamicLinks } from '../utils'

/**
 * This client should only be used for Page router pages or specifically within app.tsx.
 */
export const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  defaultOptions: {
    // setting global error policy for queries
    query: {
      errorPolicy: 'all',
    },
  },
  link: createDynamicLinks({
    tokenFunction: getBearerToken,
  }),
})
